'use strict'

module.exports = {
  cardValidatorFactory: require("./src/cardValidatorFactory")
};